<template>
  <div>
    <div style="position: absolute;right: 0.7vw;top: 31vh;z-index: 99">
      <div class="topology">
        <img @touchstart="showDialog('topology')" @click="showDialog('topology')" src="../../../../assets/images/icon/拓扑.png">
      </div>
      <div class="displayMode">
        <div class="map">
          <img class="displayImg" src="../../../../assets/images/icon/地图白.png" v-if="selected === 'map'">
          <img @touchstart="display('map')" @click="display('map')" class="displayImg" src="../../../../assets/images/icon/地图.png" v-else>
        </div>
        <div class="list">
          <img class="displayImg" src="../../../../assets/images/icon/列表白.png" v-if="selected === 'list'">
          <img @touchstart="display('list')" @click="display('list')" class="displayImg" src="../../../../assets/images/icon/列表.png" v-else>
        </div>
        <div class="setting">
          <img @touchstart="showDialog('setting')" @click="showDialog('setting')" src="../../../../assets/images/icon/设置.png">
        </div>
      </div>
    </div>

    <device-list :selectSpaceInfo="spaceInfo" v-if="selected === 'list'"></device-list>
    <device-map v-if="selected === 'map'"></device-map>

    <dialog-component
      :dialog-title="title"
      :dialogVisible.sync="dialogVisible"
      :width="width"
      @dialogClose="dialogClose">
      <div slot="content" style="padding: 10px 30px;">
        <tree-diagram style="height: 75vh;" v-if="operation === 'topology'"></tree-diagram>
        <div v-else style="padding: 0 0 40px 0">

          <display-setting :selectList="selectList" :viewMode="selectMode"
                           @getDisplayMode="getDisplayMode"></display-setting>
          <el-row style="margin-top: -20px;">
            <el-col :span="9" class="text-blueGrey" style="line-height: 28px;text-align: right;margin-right: 10px;">
              设备品牌：
            </el-col>
            <el-col :span="14" style="padding-top: 6px;">
              <el-switch
                active-color="#13ce66"
                active-text="显示"
                active-value="true"
                inactive-color="#ff4949"
                inactive-text="隐藏"
                inactive-value="false"
                style="display: block"
                v-model="showBrand">
              </el-switch>
            </el-col>
          </el-row>
          <el-row class="margin-top-10">
            <el-col :span="9" class="text-blueGrey" style="line-height: 28px;text-align: right;margin-right: 10px;">
              设备型号：
            </el-col>
            <el-col :span="14" style="padding-top: 6px;">
              <el-switch
                active-color="#13ce66"
                active-text="显示"
                active-value="true"
                inactive-color="#ff4949"
                inactive-text="隐藏"
                inactive-value="false"
                style="display: block"
                v-model="showModel">
              </el-switch>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="dialog-footer" slot="footer" style="text-align: center;margin-bottom: 15px;"
           v-if="operation !== 'topology'">
        <el-button @touchstart="dialogClose" @click="dialogClose" size="mini">关 闭</el-button>
        <el-button @touchstart="preservation" @click="preservation" size="mini" type="primary">保 存</el-button>
      </div>
    </dialog-component>
  </div>
</template>

<script>
import DeviceList from "@/views/basic_operations/monitoring/device_list/DeviceList";
import {getSystematicByCodes, saveOrUpdateSystematic} from "@/network/systematic";
import DialogComponent from "@/components/DialogComponent";
import TreeDiagram from "@/views/basic_operations/topology/TreeDiagram";
import DeviceMap from "@/views/basic_operations/monitoring/device_list/DeviceMap";
import DisplaySetting from "@/views/overview/dialogContent/DisplaySetting";

export default {
  name: "DeviceIndex",
  components: {DeviceList, DialogComponent, TreeDiagram, DeviceMap, DisplaySetting},
  inject: ['reload'],
  data() {
    return {
      codes: ["device_display_mode", "dcim_device_show_brand", "dcim_device_show_model"],
      selected: '',
      selectMode: '',
      dialogVisible: false,
      title: '',
      width: '',
      operation: '',
      selectList: [{
        id: 1,
        name: '地图',
        label: 'map',
      }, {
        id: 2,
        name: '列表',
        label: 'list',
      }],
      showBrand: true, // 显示设备品牌
      showModel: true, // 显示设备型号
      spaceInfo: null,
    }
  },
  mounted() {
    this.getByCodes()
  },
  methods: {
    //获取展示方式配置
    getByCodes() {
      getSystematicByCodes(this.codes).then(res => {
        if (res.code === 0) {
          if (res.data.length > 0) {
            res.data.forEach(item => {
              switch (item.code) {
                case 'device_display_mode':
                  this.selected = item.val1;
                  if (this.$route.query.mode && this.$route.query.mode !== "") {
                    this.selected = this.$route.query.mode;
                  }else{
                    this.selectMode = item.val1;
                  }
                  break;
                case 'dcim_device_show_brand':
                  this.showBrand = item.val1;
                  break;
                case 'dcim_device_show_model':
                  this.showModel = item.val1;
                  break;
              }
            })
          }
        }
      })
    },
    //拓扑图标事件
    showDialog(operation) {
      if (operation === 'topology') {
        this.title = '设备拓扑'
        this.width = '80%'
      } else {
        this.title = '设置呈现方式'
        this.width = '30%'
      }
      this.operation = operation
      this.dialogVisible = true;
    },
    display(val, spaceInfo) {
      this.selected = val;
      this.spaceInfo = spaceInfo;
    },
    getDisplayMode(val) {
      this.selectMode = val;
    },
    dialogClose() {
      this.dialogVisible = false;
    },
    preservation() {
      saveOrUpdateSystematic([{name: "设备一览呈现方式", code: this.codes[0], val1: this.selectMode},
        {name: "设备品牌", code: this.codes[1], val1: this.showBrand},
        {name: "设备型号", code: this.codes[2], val1: this.showModel}]).then(res => {
        if (res.code === 0) {
          this.dialogVisible = false;
          this.reload();
        }
      })
    },
  }
}
</script>

<style scoped>
.topology {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: rgba(41, 155, 255, .2);
  text-align: center;
  line-height: 45px;
}

.displayMode {
  width: 50px;
  height: 200px;
  background-color: rgba(41, 155, 255, .2);
  border-radius: 50px;
  text-align: center;
  padding-top: 40px;
  margin-top: 2px;
}

.list {
  margin-top: 15px;
  margin-bottom: 15px;
}

img {
  cursor: pointer;
}

.displayImg {
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(41, 155, 255, .2);
}
</style>
